
import PreviewLayout from '@/components/tools/preview';
import { useTypedSelector } from '@/store';

import PrivateChat from './privateChat';


export const BotBasePreview = () => {
  const { botInfo } = useTypedSelector(store => store.bot);

  return (
    <PreviewLayout>
      <PrivateChat {...botInfo} style={{ position: 'relative' }} />
    </PreviewLayout>
  );
};
